import { render, staticRenderFns } from "./CustomerReturns.vue?vue&type=template&id=80a93724&scoped=true"
import script from "./CustomerReturns.vue?vue&type=script&lang=js"
export * from "./CustomerReturns.vue?vue&type=script&lang=js"
import style0 from "./CustomerReturns.vue?vue&type=style&index=0&id=80a93724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a93724",
  null
  
)

export default component.exports